import { createAction } from 'redux-actions';
import { makeNotification } from './makeNotification';
import { actionKey } from './constants';
export var addNotificationToQueue = createAction("".concat(actionKey, ".ADD"), function (queueName, type, params) { return ({
    notification: makeNotification(type, queueName, params),
    queueName: queueName,
}); });
export var addNotification = function (type, params) {
    return addNotificationToQueue('default', type, params);
};
export var removeNotificationFromQueue = createAction("".concat(actionKey, ".REMOVE"), function (queueName, id) { return ({ id: id, queueName: queueName }); });
export var removeNotification = function (id) {
    return removeNotificationFromQueue('default', id);
};
export var removeQueues = createAction("".concat(actionKey, ".REMOVE_QUEUES"), function (predicate) { return ({ predicate: predicate }); });
//# sourceMappingURL=actionCreators.js.map